import { __HttpRequestModel__ } from 'shared/domain/httpRequest/httpRequestModel';
import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import {
  IVisibleFieldUploader,
  UploadVisibleFieldChanges,
} from 'serviceWorker/repository/visibleField/uploadVisibleField';
import { VisibleFieldInDto } from 'shared/dtos/in/visibleField';
import { addBatch } from 'serviceWorker/db/visibleFields/visibleFields';
import { scopeOfProject } from 'serviceWorker/helpers/dataScope';

export class VisibleFieldRequestRunner implements IHttpRequestRunner {
  constructor(
    private visibleFieldUploader: IVisibleFieldUploader,
    private uploadVisibieFieldChangesUseCase: UploadVisibleFieldChanges
  ) {}

  execute(request: __HttpRequestModel__): Promise<unknown> {
    return this.uploadVisibleFieldChanges(request);
  }

  private async uploadVisibleFieldChanges(
    request: __HttpRequestModel__
  ): Promise<boolean> {
    const url = `/project/${request.data.projectId}/visibleField/update`;

    const response = await this.uploadVisibieFieldChangesUseCase(
      this.visibleFieldUploader,
      request.data.visibleFieldsEdit,
      url
    );

    if (Array.isArray(response)) {
      await scopeOfProject(request.data.projectId).write(() => addBatch(response as VisibleFieldInDto[]));
    }

    return true;
  }
}
